<ng-container *ngIf="isShowingResults === false">
<div
  cdkDropList
  class="source-container"
  id="source"
  [cdkDropListConnectedTo]="groupsIds"
  [cdkDropListData]="options"
  (cdkDropListDropped)="onDrop($event)"
>
  <div class="item" *ngFor="let option of options" cdkDrag [cdkDragDisabled]="isSubmitted">
    {{ option.item.text }}
  </div>
</div>

<div class="group-container">
  <div class="group-wrap" *ngFor="let group of groups">
    <div class="titles">
      <div class="group-title">{{ group.title }}</div>
      <div class="group-subtitle" *ngIf="group.isText">{{ group.text }}</div>
    </div>
    <div
      cdkDropList
      class="group"
      [id]="group.id"
      [cdkDropListConnectedTo]="groupsIds"
      [cdkDropListData]="group.options"
      (cdkDropListDropped)="onDrop($event)"
    >
      <div *ngFor="let option of group.options" cdkDrag
           [cdkDragDisabled]="isSubmitted"
           class="item"
           [ngClass]="{
          'neutral': isSubmitted && _card.isNoCorrect,
          'correct': isSubmitted && !_card.isNoCorrect && option.item.interactionCardCategoryId === option.valueText,
          'wrong': isSubmitted && !_card.isNoCorrect && option.item.interactionCardCategoryId !== option.valueText
         }">
        {{ option.item.text }}
      </div>
    </div>
  </div>
</div>
  <app-card-button *ngIf="options.length === 0 && !isSubmitted"  [text]="'__INTERACTION_SUBMIT_RESPONSE__' | translate"  (onSubmit)="submit()"></app-card-button>

</ng-container>

<ng-container *ngIf="isShowingResults === true && results">
  <app-card-results [results]="results"></app-card-results>
  <app-card-button *ngIf="isEnableSwitchViews"
                   (click)="hideResults()" [tightLayout]="true" [text]="'__INTERACTION_DISPLAY_MY_ANSWERS__' | translate"
                   [color]="'rgba(168, 150, 246, 0.5)'" [colorInverse]="'white'"></app-card-button>
</ng-container>
